import axios from "axios"; 

const EmpDiscripencyService = {
  // Fetch all data
  async getAll(date) {
    try {
      const response = await axios.get(`/EmpDiscripency/GetEmpDiscripency?p_date=${date}`, {
        // const response = await axios.get(`http://localhost:51976/EmpDiscripency/GetEmpDiscripency?p_date=${date}`, {
        headers: {
          
        },
      });

      console.log("API response:", response.data);
      return Array.isArray(response.data.ResultSet) ? response.data.ResultSet : [];
    } catch (error) {
      console.error("Error fetching Employee ALlocation:", error);
      throw error;
    }
  },
}

export default EmpDiscripencyService;
